import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';
import {Meta, Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {LangSrcService} from '../lang-src/lang-src.service';

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  constructor(
    private titleSrv: Title,
    private metaSrv: Meta
  ) {
  }

  setMetas(metas: {
    title?: string,
    description?: string,
    robots?: string
  }) {
    this.titleSrv.setTitle((metas.title) ? `${metas.title} - Globe Speaker` : 'Globe Speaker - Learn any language, anytime, anywhere');
    this.metaSrv.addTags([
      {name: 'description', content: (metas.description) ? metas.description : null},
      {name: 'robots', content: (metas.robots) ? metas.robots : 'index, follow'}
    ]);
  }
}
